import { createAction } from '@reduxjs/toolkit';

import { TActionPayload, TDefaultAPIFailureType } from '../../types/common';

export const PROCESSING = 'PROCESSING';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';

export type DefaultActionType = TActionPayload;

export const createApiAction = <R = DefaultActionType, S = DefaultActionType, F = TDefaultAPIFailureType>(name: string) => ({
  name,
  request: createAction<R>(name),
  processing: createAction(`${name}_${PROCESSING}`),
  success: createAction<S>(`${name}_${SUCCESS}`),
  failed: createAction<F>(`${name}_${FAIL}`),
});
